import { AxiosInstance } from './Axios'

export default AxiosInstance
